// Filet de sécurité de l'espace rédaction : la saisie en cours, mémorisée en local
// à chaque frappe (débouncée), indépendamment de l'enregistrement serveur.
//
// Il ne fait pas doublon avec le statut « brouillon » stocké en base : celui-ci suppose
// un aller-retour réussi avec l'API, alors que ce qu'on protège ici est précisément ce
// qui n'a *pas encore* été envoyé. Trois pertes que ça couvre et que la base ne couvre
// pas — l'onglet fermé par mégarde, le rafraîchissement, et la session expirée en vol :
// `services/api.js` répond à un 401 par un `auth:unauthorized` qui déconnecte, et un
// article d'une heure partait avec.
//
// À noter, et c'est voulu : `AuthContext` ne retire que `access_token`, `refresh_token`
// et `user` à la déconnexion. Cette clé-ci survit donc au 401 ci-dessus, ce qui permet
// de se reconnecter et de retrouver son texte.
//
// Une clé par article en cours d'édition (plus une pour la création) : deux chantiers
// ouverts dans deux onglets ne s'écrasent pas l'un l'autre.
const cle = (editingId) => `cyclegala_blog_draft_${editingId ?? 'nouveau'}`;

export function storeBlogDraft(editingId, form) {
  try {
    localStorage.setItem(cle(editingId), JSON.stringify({ form, savedAt: Date.now() }));
    return Date.now();
  } catch (_) {
    // Navigation privée ou quota atteint : on perd le filet, pas la saisie en cours.
    // L'indicateur de sauvegarde reste muet plutôt que d'annoncer un faux succès.
    return null;
  }
}

export function readBlogDraft(editingId) {
  try {
    const brut = localStorage.getItem(cle(editingId));
    if (!brut) return null;
    const { form, savedAt } = JSON.parse(brut);
    // Un `form` absent ou non-objet vient d'une version antérieure du format ou d'une
    // écriture interrompue : mieux vaut l'ignorer que de vider le formulaire avec.
    if (!form || typeof form !== 'object') return null;
    return { form, savedAt: savedAt || null };
  } catch (_) {
    return null;
  }
}

export function clearBlogDraft(editingId) {
  try {
    localStorage.removeItem(cle(editingId));
  } catch (_) {
    // rien à faire
  }
}
